/**
 * OmniKeys — Reveal on scroll (ligero, sin dependencias)
 * Fade-up sutil de encabezados y tarjetas al entrar en viewport.
 * Preset "Scroll Reveal - Subtle": y 12px, ~450ms, ease-out, stagger 0.06s.
 *
 * Accesibilidad / SEO:
 *  - Solo oculta si JS corre (se agrega html.ok-anim); sin JS todo queda visible.
 *  - Respeta prefers-reduced-motion (no oculta nada).
 */
(function () {
  'use strict';

  var root = document.documentElement;
  // No-JS fallback: el CSS solo oculta bajo html.ok-anim, asi que si JS falla
  // o esta desactivado, el contenido se ve normal (crawlers incluidos).
  root.classList.add('ok-anim');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // el CSS deja todo visible; no animamos
  }

  // Tarjetas / items repetidos -> reveal con stagger dentro de su contenedor.
  var CARDS = [
    '.ok-beneficio-card', '.ok-stat-item', '.ok-testimonio-card',
    '.ok-hiw-step', '.ok-faq-item', '.ok-compat-os-card',
    '.ok-garantia-promise', '.ok-newsletter-card'
  ].join(',');

  // Encabezados de seccion (eyebrow + titulo) -> reveal simple.
  var HEADS = '.ok-section-label, [class*="omnikeys"] h2';

  function tag(el, delay) {
    if (el.classList.contains('ok-reveal')) return;
    el.classList.add('ok-reveal');
    if (delay) el.style.setProperty('--ok-rd', delay.toFixed(2) + 's');
  }

  try {
    document.querySelectorAll(HEADS).forEach(function (el) { tag(el, 0); });

    document.querySelectorAll(CARDS).forEach(function (el) {
      // indice entre hermanos que tambien son tarjetas -> delay escalonado
      var idx = 0, sib = el;
      while ((sib = sib.previousElementSibling)) {
        if (sib.matches && sib.matches(CARDS)) idx++;
      }
      tag(el, Math.min(idx * 0.06, 0.42));
    });
  } catch (e) {
    // si algun selector no es soportado, no rompemos la pagina
    root.classList.remove('ok-anim');
    return;
  }

  var targets = document.querySelectorAll('.ok-reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    // sin soporte: revelar todo de una
    targets.forEach(function (el) { el.classList.add('ok-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ok-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  targets.forEach(function (el) { io.observe(el); });
})();
